import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/api";
import { Check, X, Loader2 } from "lucide-react";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const tx = sp.get("tx") || "";
  const initialStatus = sp.get("status") || "pending";
  const orderId = sp.get("order_id") || "";
  const [status, setStatus] = useState(initialStatus);
  const [poll, setPoll] = useState(0);

  useEffect(() => {
    let attempts = 0; let cancelled = false;
    const tick = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/phonepe/status/${tx}`);
        if (cancelled) return;
        setStatus(data.payment_status);
        if (data.payment_status === "paid" && data.order_id) {
          setTimeout(() => nav(`/order/${data.order_id}`, { replace: true }), 800);
          return;
        }
      } catch {}
      attempts += 1; setPoll(attempts);
      if (attempts < 15 && !cancelled) setTimeout(tick, 2000);
    };
    if (tx && status !== "paid") tick();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [tx]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="payment-result">
      {status === "paid" ? (<>
        <div className="w-20 h-20 rounded-full bg-emerald-100 text-emerald-700 grid place-items-center mx-auto"><Check className="w-10 h-10"/></div>
        <h1 className="font-serif text-4xl mt-6">Payment successful!</h1>
        <p className="text-muted-foreground mt-2">Redirecting you to your order details...</p>
      </>) : status === "failed" ? (<>
        <div className="w-20 h-20 rounded-full bg-red-100 text-red-700 grid place-items-center mx-auto"><X className="w-10 h-10"/></div>
        <h1 className="font-serif text-4xl mt-6">Payment failed</h1>
        <p className="text-muted-foreground mt-2">Your payment could not be processed. No amount has been charged. Please try again or choose a different payment method.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Link to="/checkout" className="pk-btn-primary">Try again</Link>
          <Link to="/cart" className="pk-btn-secondary">Back to cart</Link>
        </div>
      </>) : (<>
        <div className="w-20 h-20 rounded-full bg-secondary/30 grid place-items-center mx-auto"><Loader2 className="w-10 h-10 text-primary animate-spin"/></div>
        <h1 className="font-serif text-4xl mt-6">Confirming your payment</h1>
        <p className="text-muted-foreground mt-2">This usually takes a few seconds. Please do not close this window. (Attempt {poll}/15)</p>
        {orderId && <Link to={`/order/${orderId}`} className="mt-6 inline-block text-primary underline">View order details</Link>}
      </>)}
    </div>
  );
}
